// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"0":"b6f15633","413":"e672dd07","481":"8536000b","522":"42084493","619":"120b8f87","834":"e64e25b0"}[chunkId] + ".css";
};